export const MAP_READY_TIMEOUT_MS = 12000;

export type MapReadyStatus =
  | "loading-units"
  | "connecting"
  | "receiving"
  | "ready"
  | "timeout";

export type MapReadyOutcome = "waiting" | "synced" | "timeout";

export interface MapReadySnapshot {
  isInitialized: boolean;
  isConnected: boolean;
  initialSyncDone: boolean;
  awaitingCompanySelection: boolean;
  hasDevices: boolean;
  hasLoadError: boolean;
}

export const isMapSynced = (s: MapReadySnapshot): boolean =>
  s.awaitingCompanySelection ||
  s.hasLoadError ||
  (s.isInitialized && s.initialSyncDone && (s.isConnected || !s.hasDevices));

export const resolveMapReadyStatus = (
  s: MapReadySnapshot,
  outcome: MapReadyOutcome,
): { ready: boolean; status: MapReadyStatus } => {
  const bypass = s.awaitingCompanySelection || s.hasLoadError;
  const ready = bypass || outcome !== "waiting";
  if (ready) {
    return { ready, status: outcome === "timeout" && !bypass ? "timeout" : "ready" };
  }
  const status: MapReadyStatus = !s.isInitialized
    ? "loading-units"
    : !s.isConnected
      ? "connecting"
      : "receiving";
  return { ready, status };
};
